/**
 * Logo Bar Template
 *
 * A row of brand/partner logo placeholders with icons and labels.
 * Framer-inspired design with evenly distributed items.
 */

const logoBar = {
  id: 'logo-bar',
  name: 'Logo Bar',
  category: 'content',
  description: 'Row of brand/partner logos',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: '#fafafa',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '40',
    paddingBottom: '40',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'logo-bar-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'md',
          alignment: 'center',
          justifyContent: 'space-around',
          flexWrap: 'wrap',
          columnLayout: { base: 'equal', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '800', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: '',
        },
        children: [
          // Logo Item 1 - Square
          {
            id: 'logo-bar-col-1',
            type: 'column',
            props: {
              gap: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 6, tablet: 2, desktop: 2 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 8, bottom: 8, left: 8, right: 8, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'logo-bar-item-1',
                type: 'container',
                props: {
                  width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'display: flex; flex-direction: row; align-items: center; gap: 8px;',
                },
                children: [
                  {
                    id: 'logo-bar-icon-1',
                    type: 'icon',
                    props: {
                      icon: 'Square',
                      iconType: 'lucide',
                      customIcon: '',
                      size: 24,
                      alignment: 'center',
                      color: '#cccccc',
                      backgroundColor: 'transparent',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'logo-bar-text-1',
                    type: 'text',
                    props: {
                      content: 'Logo',
                      element: 'span',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          // Logo Item 2 - Circle
          {
            id: 'logo-bar-col-2',
            type: 'column',
            props: {
              gap: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 6, tablet: 2, desktop: 2 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 8, bottom: 8, left: 8, right: 8, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'logo-bar-item-2',
                type: 'container',
                props: {
                  width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'display: flex; flex-direction: row; align-items: center; gap: 8px;',
                },
                children: [
                  {
                    id: 'logo-bar-icon-2',
                    type: 'icon',
                    props: {
                      icon: 'Circle',
                      iconType: 'lucide',
                      customIcon: '',
                      size: 24,
                      alignment: 'center',
                      color: '#cccccc',
                      backgroundColor: 'transparent',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'logo-bar-text-2',
                    type: 'text',
                    props: {
                      content: 'Logo',
                      element: 'span',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          // Logo Item 3 - Triangle
          {
            id: 'logo-bar-col-3',
            type: 'column',
            props: {
              gap: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 6, tablet: 2, desktop: 2 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 8, bottom: 8, left: 8, right: 8, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'logo-bar-item-3',
                type: 'container',
                props: {
                  width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'display: flex; flex-direction: row; align-items: center; gap: 8px;',
                },
                children: [
                  {
                    id: 'logo-bar-icon-3',
                    type: 'icon',
                    props: {
                      icon: 'Triangle',
                      iconType: 'lucide',
                      customIcon: '',
                      size: 24,
                      alignment: 'center',
                      color: '#cccccc',
                      backgroundColor: 'transparent',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'logo-bar-text-3',
                    type: 'text',
                    props: {
                      content: 'Logo',
                      element: 'span',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          // Logo Item 4 - Square
          {
            id: 'logo-bar-col-4',
            type: 'column',
            props: {
              gap: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 6, tablet: 2, desktop: 2 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 8, bottom: 8, left: 8, right: 8, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'logo-bar-item-4',
                type: 'container',
                props: {
                  width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'display: flex; flex-direction: row; align-items: center; gap: 8px;',
                },
                children: [
                  {
                    id: 'logo-bar-icon-4',
                    type: 'icon',
                    props: {
                      icon: 'Square',
                      iconType: 'lucide',
                      customIcon: '',
                      size: 24,
                      alignment: 'center',
                      color: '#cccccc',
                      backgroundColor: 'transparent',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'logo-bar-text-4',
                    type: 'text',
                    props: {
                      content: 'Logo',
                      element: 'span',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          // Logo Item 5 - Circle
          {
            id: 'logo-bar-col-5',
            type: 'column',
            props: {
              gap: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 6, tablet: 2, desktop: 2 },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 8, bottom: 8, left: 8, right: 8, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'logo-bar-item-5',
                type: 'container',
                props: {
                  width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'display: flex; flex-direction: row; align-items: center; gap: 8px;',
                },
                children: [
                  {
                    id: 'logo-bar-icon-5',
                    type: 'icon',
                    props: {
                      icon: 'Circle',
                      iconType: 'lucide',
                      customIcon: '',
                      size: 24,
                      alignment: 'center',
                      color: '#cccccc',
                      backgroundColor: 'transparent',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'logo-bar-text-5',
                    type: 'text',
                    props: {
                      content: 'Logo',
                      element: 'span',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.4,
                      letterSpacing: 0,
                      color: '#999999',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default logoBar;
